import { IconProps } from "@/data/types"

export default function CloseIcon({ width=30, height=30, color='black', className }: IconProps) {
  return (
    <div className={className}>
      <svg width={width} height={height} viewBox="-0.5 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
        <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
        <g id="SVGRepo_iconCarrier"> 
          <path d="M3 21.32L21 3.32001" stroke={color} strokeWidth="1" strokeLinecap="round" strokeLinejoin="round"></path> 
          <path d="M3 3.32001L21 21.32" stroke={color} strokeWidth="1" strokeLinecap="round" strokeLinejoin="round"></path> 
        </g>
      </svg>
    </div>
  )
}